//#region src/components/DownloadSelectButton/DownloadSelectButton.module.css
var e = "_errorDescriptionContainer_p2ikx_1", t = "_errorDescription_p2ikx_1", n = "_errorDescriptionIcon_p2ikx_12", r = {
	errorDescriptionContainer: e,
	errorDescription: t,
	errorDescriptionIcon: n
};
//#endregion
export { r as default, t as errorDescription, e as errorDescriptionContainer, n as errorDescriptionIcon };
